import { loadAndPlayAudio, preloadAudio, stopAudio, } from './modules/audio/loadAndPlayAudio';
// uis
const SOUND_PRESS_URL = '/audios/general/button.wav';
// ticking
const SOUND_TICKING_FAST_URL = '/audios/ticking/ticking-fast.mp3';
const SOUND_TICKING_SLOW_URL = '/audios/ticking/ticking-slow.mp3';
const SOUND_BROWN_NOISE_URL = '/audios/ticking/ticking-brown.mp3';
const SOUND_WHITE_NOISE_URL = '/audios/ticking/ticking-white.mp3';
// alarms
const SOUND_ALARM_BELL_URL = '/audios/alarms/alarm-bell.mp3';
const SOUND_ALARM_BIRD_URL = '/audios/alarms/alarm-bird.mp3';
const SOUND_ALARM_DIGITAL_URL = '/audios/alarms/alarm-digital.mp3';
const SOUND_ALARM_KITCHEN_URL = '/audios/alarms/alarm-kitchen.mp3';
const SOUND_ALARM_WOOD_URL = '/audios/alarms/alarm-wood.mp3';
// pop
const SOUND_POP_01_URL = '/audios/pop/pop01.mp3';
const SOUND_POP_02_URL = '/audios/pop/pop02.mp3';
const SOUND_POP_03_URL = '/audios/pop/pop03.mp3';
const SOUND_POP_04_URL = '/audios/pop/pop04.mp3';
const SOUND_POP_05_URL = '/audios/pop/pop05.mp3';
// audios
const AUDIO_PRESS = new Audio(SOUND_PRESS_URL);
const AUDIO_TICKING_FAST_1 = new Audio(SOUND_TICKING_FAST_URL);
const AUDIO_TICKING_FAST_2 = new Audio(SOUND_TICKING_FAST_URL);
const AUDIO_TICKING_SLOW_1 = new Audio(SOUND_TICKING_SLOW_URL);
const AUDIO_TICKING_SLOW_2 = new Audio(SOUND_TICKING_SLOW_URL);
const AUDIO_BROWN_NOISE_1 = new Audio(SOUND_BROWN_NOISE_URL);
const AUDIO_BROWN_NOISE_2 = new Audio(SOUND_BROWN_NOISE_URL);
const AUDIO_WHITE_NOISE_1 = new Audio(SOUND_WHITE_NOISE_URL);
const AUDIO_WHITE_NOISE_2 = new Audio(SOUND_WHITE_NOISE_URL);
const AUDIO_ALARM_BELL = new Audio(SOUND_ALARM_BELL_URL);
const AUDIO_ALARM_BIRD = new Audio(SOUND_ALARM_BIRD_URL);
const AUDIO_ALARM_DIGITAL = new Audio(SOUND_ALARM_DIGITAL_URL);
const AUDIO_ALARM_KITCHEN = new Audio(SOUND_ALARM_KITCHEN_URL);
const AUDIO_ALARM_WOOD = new Audio(SOUND_ALARM_WOOD_URL);
const AUDIO_POP = new Audio(SOUND_POP_05_URL);
const AUDIO_POP_POMO = new Audio(SOUND_POP_04_URL);
// load
AUDIO_PRESS.load();
AUDIO_TICKING_FAST_1.load();
AUDIO_TICKING_FAST_2.load();
AUDIO_TICKING_SLOW_1.load();
AUDIO_TICKING_SLOW_2.load();
AUDIO_BROWN_NOISE_1.load();
AUDIO_BROWN_NOISE_2.load();
AUDIO_WHITE_NOISE_1.load();
AUDIO_WHITE_NOISE_2.load();
AUDIO_ALARM_BELL.load();
AUDIO_ALARM_BIRD.load();
AUDIO_ALARM_DIGITAL.load();
AUDIO_ALARM_KITCHEN.load();
AUDIO_ALARM_WOOD.load();
AUDIO_POP.load();
AUDIO_POP_POMO.load();
/**
 * Ticking Sounds
 */
export const TICKING_NONE = 'ticking_none';
export const TICKING_FAST = 'ticking_fast';
export const TICKING_SLOW = 'ticking_slow';
// test
export const WHITE_NOISE = 'ticking_white';
export const BROWN_NOISE = 'ticking_brown';
let tickingVolume = 1;
export const TICKING_SOUND_SELECTION = [
    {
        id: TICKING_NONE,
        seamlessLoop: false,
        audios: [null, null],
        text: 'None',
        url: '',
    },
    {
        id: TICKING_FAST,
        seamlessLoop: false,
        audios: [AUDIO_TICKING_FAST_1, AUDIO_TICKING_FAST_2],
        text: 'Ticking Fast',
        url: SOUND_TICKING_FAST_URL,
    },
    {
        id: TICKING_SLOW,
        seamlessLoop: false,
        audios: [AUDIO_TICKING_SLOW_1, AUDIO_TICKING_SLOW_2],
        text: 'Ticking Slow',
        url: SOUND_TICKING_SLOW_URL,
    },
    // test
    {
        id: WHITE_NOISE,
        seamlessLoop: true,
        audios: [AUDIO_WHITE_NOISE_1, AUDIO_WHITE_NOISE_2],
        text: 'White Noise',
        url: SOUND_WHITE_NOISE_URL,
    },
    {
        id: BROWN_NOISE,
        seamlessLoop: true,
        audios: [AUDIO_BROWN_NOISE_1, AUDIO_BROWN_NOISE_2],
        text: 'Brown Noise',
        url: SOUND_BROWN_NOISE_URL,
    },
];
/**
 * Alarm Sounds
 */
export const ALARM_BELL = 'alarm_bell';
export const ALARM_BIRD = 'alarm_bird';
export const ALARM_DIGITAL = 'alarm_digital';
export const ALARM_KITCHEN = 'alarm_kitchen';
export const ALARM_VOICE = 'alarm_voice';
export const ALARM_WOOD = 'alarm_wood';
let alarmVolume = 1;
export const ALARM_SOUND_SELECTION = [
    {
        id: ALARM_BELL,
        audio: AUDIO_ALARM_BELL,
        text: 'Bell',
    },
    {
        id: ALARM_BIRD,
        audio: AUDIO_ALARM_BIRD,
        text: 'Bird',
    },
    {
        id: ALARM_DIGITAL,
        audio: AUDIO_ALARM_DIGITAL,
        text: 'Digital',
    },
    {
        id: ALARM_KITCHEN,
        audio: AUDIO_ALARM_KITCHEN,
        text: 'Kitchen',
    },
    {
        id: ALARM_WOOD,
        audio: AUDIO_ALARM_WOOD,
        text: 'Wood',
    },
];
let playTimes = 0;
let repeatTimes = 0;
let beepToPlay = null;
const playSoundBeepLoop = () => {
    try {
        if (playTimes < repeatTimes) {
            beepToPlay.play();
            playTimes += 1;
            beepToPlay.removeEventListener('ended', playSoundBeepLoop, false);
            beepToPlay.addEventListener('ended', playSoundBeepLoop, false);
        }
    }
    catch (err) {
        console.log('playSoundBeepLoop error:', err);
    }
};
export const stopSoundBeep = () => {
    try {
        beepToPlay.pause();
        playTimes = 0;
        repeatTimes = 0;
    }
    catch (err) {
        //
    }
};
export const playSoundBeep = (soundId, _repeatTimes) => {
    try {
        stopSoundBeep();
        const _sound = ALARM_SOUND_SELECTION.find((s) => s.id === soundId);
        playTimes = 0;
        repeatTimes = _repeatTimes;
        beepToPlay = _sound.audio;
        beepToPlay.volume = alarmVolume;
        playSoundBeepLoop();
    }
    catch (err) {
        throw err;
    }
};
export const playSoundPress = () => {
    try {
        AUDIO_PRESS.volume = 0.2;
        AUDIO_PRESS.play();
    }
    catch (err) { }
};
let tickingToPlay = [];
export const preloadSoundTicking = (soundId) => {
    try {
        const sound = TICKING_SOUND_SELECTION.find((s) => s.id === soundId);
        if (sound && sound.url) {
            preloadAudio(sound.url, sound.seamlessLoop);
        }
    }
    catch (err) { }
};
export const startSoundTicking = (soundId, partially) => {
    try {
        const sound = TICKING_SOUND_SELECTION.find((s) => s.id === soundId);
        loadAndPlayAudio(sound.url, tickingVolume, partially, sound.seamlessLoop);
    }
    catch (err) { }
};
export const stopSoundTicking = () => {
    try {
        stopAudio();
        // @ts-ignore - tickingWorker is defined globally
        tickingWorker.postMessage('ticking-stop');
    }
    catch (err) { }
};
export const isTicking = () => {
    try {
        let ticking = false;
        tickingToPlay.forEach((t) => {
            if (!t.paused)
                ticking = true;
        });
        return ticking;
    }
    catch (err) {
        return false;
    }
};
export const changeSoundVolume = (volume) => {
    alarmVolume = volume / 100;
};
export const changeTickingVolume = (volume) => {
    tickingVolume = volume / 100;
};
export const playSoundPop = (popCount) => {
    try {
        AUDIO_POP.volume = 1;
        AUDIO_POP.play();
        // if (popCount > 0) {
        //   for (let i = 0; i < popCount; i++) {
        //     setTimeout(() => {
        //       const popAudio = new Audio(SOUND_POP_04_URL);
        //       popAudio.volume = 0.25;
        //       popAudio.play();
        //     }, i * 80 + Math.random() * 50);
        //   }
        // }
    }
    catch (err) { }
};
// let tickingInterval = null;
// export function setupOverlappingFadeAudio([audio1, audio2]) {
//   audio1.loop = false;
//   audio2.loop = false;
//   const fadeinSeconds = 2;
//   const audioDuration = Math.floor(audio1.duration);
//   const interval = audioDuration - fadeinSeconds;
//   audio1.play();
//   tickingWorker.postMessage(`ticking-start_${interval}`);
//   tickingWorker.onmessage = message => {
//     if (message.data === 'ticking-switch') {
//       switchAudioWithFade(audio1, audio2, fadeinSeconds);
//     }
//   };
// tickingInterval = setInterval(() => {
//   switchAudioWithFade(audio1, audio2, fadeinSeconds);
// }, interval * 1000);
// }
// function switchAudioWithFade(audio1, audio2, fadeinSeconds) {
//   const playingAudio = audio2.currentTime === 0 ? audio1 : audio2;
//   const nextAudio = playingAudio === audio1 ? audio2 : audio1;
//   fadeoutAudio(playingAudio, fadeinSeconds, 0.2);
//   fadeinAudio(nextAudio, fadeinSeconds, 0.2);
// }
// function fadeoutAudio(playingAudio, fadeoutSeconds, fadeStep) {
//   let remainingSeconds = fadeoutSeconds;
//   let volume = 1;
//   const fadeout = setInterval(() => {
//     volume = remainingSeconds / fadeoutSeconds;
//     volume = enhanceVolume(volume);
//     if (volume <= 0) {
//       clearInterval(fadeout);
//       playingAudio.pause();
//       playingAudio.currentTime = 0;
//       return;
//     }
//     playingAudio.volume =
//       Math.floor(volume * tickingVolume * 100) / 100;
//     remainingSeconds -= fadeStep;
//   }, fadeStep * 1000);
// }
// function fadeinAudio(nextAudio, fadeinSeconds, fadeStep) {
//   let remainingSeconds = fadeinSeconds;
//   let volume = 0;
//   nextAudio.volume = volume;
//   nextAudio.play();
//   const fadein = setInterval(() => {
//     volume =
//       remainingSeconds === 0
//         ? 1
//         : 1 - remainingSeconds / fadeinSeconds;
//     volume = enhanceVolume(volume);
//     if (volume >= 1) {
//       clearInterval(fadein);
//       return;
//     }
//     nextAudio.volume = Math.floor(volume * tickingVolume * 100) / 100;
//     remainingSeconds -= fadeStep;
//   }, fadeStep * 1000);
// }
// function enhanceVolume(volume) {
//   const addingVolume = (1 - volume) / 4;
//   return volume;
// }
